import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import ToggleButton from '../button/ToggleButton';

import styles from './styles/FormToggle.module.css';

const FormToggle = ({
    checked = false,
    onChange,
    disabled = false,
    title,
    description,
    size = 'medium',
    className = '',
    id,
    name,
    ...props
}) => {
    const handleToggle = useCallback(() => {
        if (onChange && !disabled) {
            onChange(!checked);
        }
    }, [onChange, disabled, checked]);

    return (
        <label
            className={`${styles.toggleLabel} ${disabled ? styles.disabled : ''} ${className}`}
            htmlFor={id}
            {...props}
        >
            <div className={styles.toggleContent}>
                <div className={styles.textContent}>
                    {title && (
                        <span className={styles.toggleTitle}>{title}</span>
                    )}
                    {description && (
                        <span className={styles.toggleDescription}>
                            {description}
                        </span>
                    )}
                </div>
                <ToggleButton
                    isEnabled={checked}
                    onChange={handleToggle}
                    size={size}
                    disabled={disabled}
                />
            </div>
            {/* Hidden input for form compatibility */}
            <input
                type="checkbox"
                id={id}
                name={name}
                checked={checked}
                onChange={() => {}} // Handled by ToggleButton
                style={{ display: 'none' }}
            />
        </label>
    );
};

FormToggle.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium']),
    className: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
};

export default memo(FormToggle);
